/**
 * Area is "active" when at least one supervisor has this area switched on in the app.
 * @param {object} area
 * @returns {boolean}
 */
export function isWorkingAreaActive(area) {
	if (!area) return false
	return Number(area.active_supervisors_count || 0) > 0
}
